<template>
  <v-dialog :value="visible" width="600px" @click:outside="onClose">
    <v-card>
      <v-card-title> Lägg till källa </v-card-title>
      <v-card-text>
        <v-text-field class="mb-2" outlined label="Titel" v-model="link_title"></v-text-field>
        <v-text-field
          class="mb-2"
          outlined
          label="Källa"
          v-model="link_description"
          messages="T.ex. Forskning.se, Havsutsikt, etc."
        ></v-text-field>
        <v-text-field
          class="mb-2"
          outlined
          label="Länk"
          messages="https://..."
          v-model="link_url"
        ></v-text-field>
        <DatePicker
          :date="link_date_created"
          :show-icon="false"
          label="Datum"
          @change="onChangeDate"
        />
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="onClose"> Stäng </v-btn>
        <v-btn color="primary" :loading="loading" text @click="save"> Lägg till </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
/* eslint camelcase: 0 */
import DatePicker from '../shared/DatePicker'
import moment from 'moment'

export default {
  name: 'AddNewsSource',
  components: {
    DatePicker,
  },
  props: {
    loading: { type: Boolean },
    visible: { type: Boolean, default: false },
  },
  data() {
    return {
      link_description: '',
      link_title: '',
      link_url: '',
      link_date_created: moment().format('YYYY-MM-DD'),
    }
  },
  methods: {
    save() {
      const { link_description, link_title, link_url, link_date_created } = this
      this.$emit('add-link', { link_description, link_title, link_url, link_date_created })
      this.link_description = ''
      this.link_title = ''
      this.link_url = ''
      this.$emit('close')
    },
    onChangeDate(date) {
      this.link_date_created = date
    },
    onClose() {
      this.$emit('close')
    },
  },
}
</script>

<style lang="less" scoped>
.add-news-source {
  padding: 0;
  .footer {
    display: flex;
    justify-content: flex-end;
  }
}
</style>
